import React, { useMemo } from 'react'

import TableRow from 'components_new/atoms/Table/TableRow'

import FooterCell from '../FooterCell'
import { useTheme } from '@mui/material'
import { TableColumn } from '../index'

interface FixedFooterContentProps {
  columns: TableColumn[]
  scaleFactor: number
}

const FooterContent = (props: FixedFooterContentProps) => {
  const { columns, scaleFactor } = props

  const theme = useTheme()

  const footerCells = useMemo(
    () =>
      columns.map((column) => (
        <FooterCell
          increaseIsPositive={column.totalIncreaseIsPositive}
          key={column.index}
          percentageDiff={column.totalPercentageDiff}
          scaleFactor={scaleFactor}
          showTrendTag={column.totalShowTrendTag}
          value={column.total ?? ''}
        />
      )),
    [columns, scaleFactor]
  )

  return (
    <TableRow
      sx={{
        position: 'relative',
        bgcolor: theme.palette.background.widget,
        backgroundImage: `linear-gradient(${theme.palette.background.overlay}, ${theme.palette.background.overlay})`
      }}
    >
      <FooterCell
        align={'start'}
        scaleFactor={scaleFactor}
        stickyLeft={0}
        value={'Totalt'}
      />
      {footerCells}
    </TableRow>
  )
}

export default FooterContent
